import { odinClient } from "@/config/client"
import type { ClientResponse } from "@educabot/fetcher/lib/types"

export interface UpdateStudySessionParams {
  lessonId: string
  studyLessonId: string
  payload: {
    userMessage: string
    finalLesson: boolean
  }
}

export interface UpdateStudySessionResponse {
  description: {
    agentMessage: string
    displayButtons: boolean
    approved: boolean
    indications: null
  }
}

export function updateStudySession(
  params: UpdateStudySessionParams,
): Promise<ClientResponse<UpdateStudySessionResponse>> {
  return odinClient.put(
    `/v1/activities/${params.lessonId}/lessons/study-session/${params.studyLessonId}`,
    params.payload,
  )
}
